import type { ReactNode } from 'react';

/**
 * The thin status strip of Screens 11c — one calm line, no icon, no colour. It carries offline
 * on Today and Words, and "a new version is ready" in the Shell.
 *
 * 11c's rule is that there is exactly one thin banner and it never shouts: a failure the learner
 * can do nothing about gets a sentence, not an alert.
 */
export function InfoStrip({
  children,
  action,
  border = 'bottom',
}: {
  children: ReactNode;
  /** An optional trailing control — "Reload" on the update line. */
  action?: ReactNode;
  /** `bottom` when the strip sits at the top of a screen, `top` when it sits at the bottom. */
  border?: 'bottom' | 'top';
}) {
  return (
    <div
      role="status"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        padding: '7px 14px',
        fontSize: 11.5,
        lineHeight: 1.45,
        color: 'var(--nn-muted)',
        background: 'var(--nn-panel-2)',
        [border === 'bottom' ? 'borderBottom' : 'borderTop']: '1px solid var(--nn-hairline)',
      }}
    >
      <span style={{ flex: 1, minWidth: 0 }}>{children}</span>
      {action}
    </div>
  );
}
